var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-card-title", [_vm._v("System Settings Dispatch")]),
      _c(
        "v-card-text",
        [
          _c("p", { staticClass: "text-subtitle-2 mb-1" }, [
            _vm._v("Summer Week"),
          ]),
          _c(
            "v-card",
            { staticClass: "d-flex", attrs: { flat: "" } },
            [
              _c("InputDate", {
                staticClass: "pr-2",
                attrs: { label: "From", dense: "" },
                model: {
                  value: _vm.summer,
                  callback: function ($$v) {
                    _vm.summer = $$v
                  },
                  expression: "summer",
                },
              }),
              _c("v-text-field", {
                staticClass: "pl-2",
                attrs: { label: "To", readonly: "" },
                model: {
                  value: _vm.summerEnd,
                  callback: function ($$v) {
                    _vm.summerEnd = $$v
                  },
                  expression: "summerEnd",
                },
              }),
            ],
            1
          ),
          _c("p", { staticClass: "text-subtitle-2 mb-1" }, [
            _vm._v("Winter Week"),
          ]),
          _c(
            "v-card",
            { staticClass: "d-flex", attrs: { flat: "" } },
            [
              _c("InputDate", {
                staticClass: "pr-2",
                attrs: { label: "From", dense: "" },
                model: {
                  value: _vm.winter,
                  callback: function ($$v) {
                    _vm.winter = $$v
                  },
                  expression: "winter",
                },
              }),
              _c("v-text-field", {
                staticClass: "pl-2",
                attrs: { label: "To", readonly: "" },
                model: {
                  value: _vm.winterEnd,
                  callback: function ($$v) {
                    _vm.winterEnd = $$v
                  },
                  expression: "winterEnd",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }